import type { RouterContextType } from "@/api/permissions/permissions.api";
import { MODULE_KEYS_MAP } from "@/api/permissions/permissions.types";
import { DropdownsTab } from "@/components/features/FormManager/DropdownsTab";
import { EquipmentTab } from "@/components/features/FormManager/EquipmentTab";
import { SuppliersTab } from "@/components/features/FormManager/SuppliersTab";
import { TradesTab } from "@/components/features/FormManager/TradesTab";
import styles from "@/components/features/FormManager/FormManager.module.scss";
import { useBreadcrumb } from "@/hooks/useBreadcrumb";
import { authGuardWithPermissions } from "@/utils/authGuard";
import { getRouteIcon } from "@/utils/getRouteIconComponent";
import { Flex, Tabs, Text, Title } from "@mantine/core";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/form-manager/")({
  component: FormManager,
  beforeLoad: async (args) => {
    await authGuardWithPermissions({
      context: args.context as RouterContextType,
      location: args.location as { pathname: string },
    });
  },
});

function FormManager() {
  useBreadcrumb(
    [
      {
        title: "Dropdown & Form Manager",
        href: "/form-manager",
        icon: getRouteIcon(MODULE_KEYS_MAP.settings),
      },
    ],
    { listView: "List View" },
  );

  return (
    <Flex
      direction="column"
      p="var(--spacing-large)"
      gap="var(--spacing-medium)"
      h="100%"
      className={styles.pageCard}
    >
      <Flex direction="column" gap={4}>
        <Title order={3}>Dropdown & Form Manager</Title>
        <Text size="sm" c="dimmed">
          Manage the dropdown and list values that forms across ServEngine consume
        </Text>
      </Flex>

      <Tabs defaultValue="dropdowns" keepMounted={false} className={styles.tabsRoot}>
        <Tabs.List>
          <Tabs.Tab value="dropdowns">Dropdowns</Tabs.Tab>
          <Tabs.Tab value="trades">Trades & Sub-trades</Tabs.Tab>
          <Tabs.Tab value="equipment">Equipment</Tabs.Tab>
          <Tabs.Tab value="suppliers">Suppliers</Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value="dropdowns" pt="var(--spacing-medium)" className={styles.dropdownsPanel}>
          <DropdownsTab />
        </Tabs.Panel>
        <Tabs.Panel value="trades" pt="var(--spacing-medium)">
          <TradesTab />
        </Tabs.Panel>
        <Tabs.Panel value="equipment" pt="var(--spacing-medium)">
          <EquipmentTab />
        </Tabs.Panel>
        <Tabs.Panel value="suppliers" pt="var(--spacing-medium)">
          <SuppliersTab />
        </Tabs.Panel>
      </Tabs>
    </Flex>
  );
}
